import { FC, memo } from 'react'
import { Flex, FlexProps, Text } from '@chakra-ui/react'

import { ActivityFilter } from 'Activities/types'

type Props = FlexProps & {
  activityFilter: ActivityFilter
}

const DataFilterFeedback: FC<Props> = ({ activityFilter, ...flexProps }) => {
  if (activityFilter.origin_created_at_feedback === '') return null

  return (
    <Flex direction="column" align="flex-start" gap={1} {...flexProps}>
      <Text fontSize="md">Está filtrando pelo período: </Text>
      <Text textAlign="left" color="primary" fontSize="md">
        {activityFilter.origin_created_at_feedback}
      </Text>
    </Flex>
  )
}

export default memo(DataFilterFeedback)
